/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function CreateDocumentFolderRequestDocumentFolderFromJSON(json) {
    return CreateDocumentFolderRequestDocumentFolderFromJSONTyped(json, false);
}
export function CreateDocumentFolderRequestDocumentFolderFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: json['name']
    };
}
export function CreateDocumentFolderRequestDocumentFolderToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name
    };
}
